import { Expose, Type } from "class-transformer"
import { Employee } from "../employee/employee"
import ActivityHistoryLog from "./activity-history-log"

interface LoggedDetails {
  companyName: string | null
  companyId: number | null
  dswCode: string | null
  username: string
  officeName: string | null
  officeStreet: string | null
  officeHouseNumber: string | null
  officeCity: string | null
  officeZip: string | null
}

class LoginAsOtherLog extends ActivityHistoryLog {

  @Expose()
  @Type(() => Employee)
  public otherEmployee: Employee | null = null

  public getloggedUserInfo() {
      return this.getEmployeeData(this.otherEmployee)
  }

  private getEmployeeData(data: Employee): LoggedDetails {
    const { office = null } = data
    const { company = null }  = office

    return {
      companyName: company ? company.name : null,
      companyId: company ? company.id : null,
      dswCode:  company ? company.dswCode : null,
      username: data.username,
      officeName: office ? office.officeName : null,
      officeStreet: office ? office.officeStreet : null,
      officeHouseNumber: office ? office.officeHouseNumber : null,
      officeCity: office ? office.officeCity : null,
      officeZip: office ? office.officeZip : null
    }
  }

  public getUser() {
    const data = this.activityHistory.employee
    return this.getEmployeeData(data)
  }

}

export default LoginAsOtherLog
export {
  LoggedDetails
}
